export enum PostSchema {
  "Years" = "yearFilterEntries",
  "Category" = "otherFilterEntries",
  "Locations" = "locationsEntries",
  "Featured Insights" = "otherFilterEntries",
  "Expertise" = "expertiseEntries",
  "Markets" = "marketEntries",
  "Regions" = "regionEntries",
}

export enum QueryStringSchema {
  "Years" = "filterby-year",
  "Category" = "filterby-other",
  "Locations" = "filterby-location",
  "Featured Insights" = "filterby-other",
  "Expertise" = "filterby-expertise",
  "Markets" = "filterby-market",
  "Regions" = "filterby-region",
}

export enum URLQueryStringSchema {
  "filterby-year" = "Years",
  "filterby-other" = "Category",
  "filterby-location" = "Locations",
  "filterby-expertise" = "Expertise",
  "filterby-market" = "Markets",
  "filterby-region" = "Regions",
}
